// @ts-nocheck
import * as React from 'react'
import { OneFieldModal, NoFieldModal, MoveOrMergeModal, DeleteCatModal } from './Modals'
import {
    TreeView,
    processTreeViewItems,
    handleTreeViewCheckChange,
    moveTreeViewItem,
    TreeViewDragAnalyzer,
    TreeViewDragClue,
    ItemRenderProps,
    TreeViewItemDragEndEvent,
    TreeViewItemDragStartEvent,
    TreeViewItemDragOverEvent,
} from '@progress/kendo-react-treeview'
import '@progress/kendo-react-animation'
import { Menu, Item, Separator, Submenu, contextMenu } from 'react-contexify'
// import { Menu, MenuItem } from '@progress/kendo-react-layout';
import { Popup, Offset } from '@progress/kendo-react-popup'
import { Menu as KMenu, MenuItem as KMenuItem, MenuSelectEvent } from '@progress/kendo-react-layout'
import 'react-contexify/dist/ReactContexify.min.css'
import './TreePanel.css'

import SortByAlphaIcon from '@material-ui/icons/SortByAlphaOutlined'
import ImportExportIcon from '@material-ui/icons/ImportExport'
import { getBaseURL } from '../../GlobalComponents/URLs'

/**
 * AttributeCount: null
CategoryId: 928
DisplayOrder: 0
MenuVisible: true
MktImageHL: ""
MktStatement: ""
Name: ""
NamePath: "0 - Archived Categories > Test Main Category > Test Sub Category 1 B > Ultrasonic Sensor > "
ParentId: 926
PartCount: 0
PathFromRoot: "|1974|1952|1958|926|928|"
PrimaryTechnology: 0
SideMktImageHL: ""
Technologies: Array(1)
0: 4
 */
const ADD_SUBCATEGORY_URL = `${getBaseURL()}webapi/invtcategoryattribute/add`
const DELETE_CATEGORY_URL = `${getBaseURL()}webapi/invtcategoryattribute/delete`
const DELETE_RECURSIVE_URL = `${getBaseURL()}webapi/invtcategoryattribute/deleteRecursive`
const MERGE_CATEGORY_URL = `${getBaseURL()}webapi/invtcategoryattribute/merge`
const MOVE_CATEGORY_URL = `${getBaseURL()}webapi/invtcategoryattribute/move`
const CAT_SAVE_URL = `${getBaseURL()}webapi/invtcategoryattribute/update/`

const DELETE_SUCCESSFUL_TEXT = 'Deleted Category Successfully'
const MOVE_SUCCESSFUL_TEXT = 'Moved Category Successfully'
const ADD_SUBCATEGORY_SUCCESSFUL_TEXT = 'Added Category Successfully'
const ADD_CATEGORY_SUCCESSFUL_TEXT = 'Added Category Successfully'
const RENAME_CATEGORY_SUCCESSFUL_TEXT = 'Renamed Category Successfully'
const MERGE_CATEGORY_SUCCESSFUL_TEXT = 'Merged Category Successfully'

const SEPARATOR = '_'

const Orders = {
    DISPLAY: 'displayOrder',
    ALPHA: 'alphabetical',
}

interface Category {
    CategoryId: number
    ParentId: number
    Name: string
    MenuVisible: boolean
}

interface TreeNode {
    node: Category
    items: Array<TreeNode>
    text: string
    selected?: boolean
}
//retype item to a category item
interface TreeItemRenderProps extends Omit<ItemRenderProps, 'item'> {
    item: TreeNode
}

interface DragStartEvent extends Omit<TreeViewItemDragStartEvent, 'item'> {
    item: TreeNode
}

interface DragEndEvent extends Omit<TreeViewItemDragEndEvent, 'item'> {
    item: TreeNode
}
interface DragOverEvent extends Omit<TreeViewItemDragOverEvent, 'item'> {
    item: TreeNode
}
let handleContextEvent = (menuId) => {
    return (e) => {
        e.preventDefault()
        e.stopPropagation()
        contextMenu.show({
            id: menuId,
            event: e,
            props: {
                foo: 'bar',
            },
        })
    }
}

interface TreeItemMenuProps {
    onCategoryClick(e: any): void
    onSubCategoryClick(e: any): void
    onDeleteClick(e: any): void
    onRenameClick(e: any): void
    // inContextRef: React.Ref<any>,
    menuId: any
}
{
    /* <TreeItemMenu menuId={menuId} nodeId={baseNode} parentId={parentNode} inContextRef={inContextRef}/> */
}
const TreeItemMenu = (props: TreeItemMenuProps) => (
    <Menu
        style={{ zIndex: 100000000 }}
        id={props.menuId}
        onShown={() => {
            // props.inContextRef.current = true
        }}
        onHidden={() => {
            // props.inContextRef.current = false
        }}
    >
        <Submenu label="Add">
            <Item onClick={props.onCategoryClick}>Category</Item>
            <Item onClick={props.onSubCategoryClick}>Sub-category</Item>
        </Submenu>
        <Item onClick={props.onDeleteClick}>Delete</Item>
        <Item onClick={props.onRenameClick}>Rename</Item>
    </Menu>
)

const TreeItemMenu2 = (props) => {}

// they use weird indices like 0_4_5 meaning index 0 in first list, 4 in subitems list .....
const getItemFromIndex = (tree: Array<TreeNode>, index: string): TreeNode | Array<TreeNode> => {
    if (index === '') return tree
    let indices = index.split('_')
    let res: TreeNode
    let currentTree = tree
    indices.forEach((ind) => {
        res = currentTree[ind]
        currentTree = res.items
    })
    return res
}

const getParentIndex = (index: string): string => {
    let indices = index.split('_')
    indices.pop()
    return indices.join('_')
}

const treeItemAlphaSort = (a, b) => {
    if (a.node.Name < b.node.Name) return -1
    else if (a.node.Name > b.node.Name) return 1
    else return a.DisplayOrder - b.DisplayOrder
}

const treeItemDisplayOrderSort = (a, b) => {
    if (a.node.DisplayOrder > b.node.DisplayOrder) return 1
    else if (a.node.DisplayOrder < b.node.DisplayOrder) return -1
    else return a.node.Name < b.node.Name ? -1 : 1
}

const orderTreeAlphabetical = (tree) => {
    tree.sort(treeItemAlphaSort)
    tree.forEach((kNode) => orderTreeAlphabetical(kNode.items))
    // Object.keys(tree).forEach(key => tree[key].items.sort(treeItemAlphaSort)
}

const orderTreeDisplayOrder = (tree) => {
    tree.sort(treeItemDisplayOrderSort)
    tree.forEach((kNode) => orderTreeDisplayOrder(kNode.items))
}

const orderTree = (setTree, order) => {
    setTree((tree) => {
        if (order === Orders.ALPHA) {
            orderTreeAlphabetical(tree)
        } else if (order === Orders.DISPLAY) {
            orderTreeDisplayOrder(tree)
        }
        return [...tree]
    })
}

const setSelected = (tree: Array<TreeNode>, categoryId) => {
    tree.forEach((node) => (node.selected = node.node.CategoryId === categoryId))
    tree.forEach((node) => setSelected(node.items, categoryId))
}
// setAlertText
// refreshTree
const TreePanel = (props) => {
    const [selectedItem, setSelectedItem] = React.useState<any>(false)
    const [currentModal, setCurrentModal] = React.useState<any>(null)
    const [contextOpen, setContextOpen] = React.useState<boolean>(false)
    const [contextOffset, setContextOffset] = React.useState<null | Offset>(null)
    const [alphaOrder, setAlphaOrder] = React.useState(false)

    React.useEffect(() => {
        orderTree(props.setTreeInfo, alphaOrder ? Orders.ALPHA : Orders.DISPLAY)
    }, [alphaOrder, props.treeReloaded])

    React.useEffect(() => {
        props.setTreeInfo((tree) => {
            setSelected(tree, props.currentCategory)
            return [...tree]
        })
    }, [props.currentCategory])

    const { treeDict } = props
    const dragClueRef = React.useRef<any>()
    const currentItemRef = React.useRef<any>()

    React.useEffect(() => {
        // for contextMenu click away
        let click = () => setContextOpen(false) // for contextMenu click away
        document.addEventListener('click', click)
        return () => document.removeEventListener('click', click)
    }, [])
    const handleContextMenuOpen = (e, dataItem) => {
        // this.dataItem = dataItem;
        // this.dataItemIndex = this.state.gridData.findIndex(p => (p.ProductID === this.dataItem.ProductID));
        e.preventDefault()
        let offset = { left: e.clientX, top: e.clientY }
        setContextOffset(offset)
        setContextOpen(true)
        currentItemRef.current = dataItem
    }

    const handleOnSelect = (e: MenuSelectEvent) => {
        if (!currentItemRef.current) {
            return
        } else {
            let node = currentItemRef.current
            let onCategoryClick = getCategoryOnClick(node.CategoryId, node.ParentId)
            let onSubCategoryClick = getSubCategoryOnClick(node.CategoryId, node.ParentId)
            let onRenameClick = getRenameOnClick(node.CategoryId, node.ParentId)
            let onDeleteClick = getRemoveOnClick(node.CategoryId, node.ParentId)
            switch (e.item.text) {
            case 'SubCategory':
                onSubCategoryClick()
                break
            case 'Category':
                onCategoryClick()
                break
            case 'Rename':
                onRenameClick()
                break
            case 'Delete':
                onDeleteClick()
                break
            default:
                break
            }
        }
        document.execCommand('copy')
    }
    const TreeViewItem = (props: TreeItemRenderProps) => {
        const [show, setShow] = React.useState(false)
        const [offset, setOffset] = React.useState({ left: 0, top: 0 })
        const handleContextMenu = (e) => {
            e.preventDefault()
            setOffset({ left: e.clientX, top: e.clientY })
            setShow(true)
        }
        let node = props.item.node
        const close = () => {
            setShow(false)
        }
        // React.useEffect(()=>{
        //     document.addEventListener("contextmenu", close)
        //     return document.removeEventListener("contextmenu", close)
        // },[])
        // weird margin to steal real estate from parent component kendo doesn't give control of
        return (
            <div
                style={
                    props.item.node.MenuVisible || props.item.selected
                        ? {}
                        : {
                            backgroundColor: '#a1a3a6',
                            margin: '-4px -8px',
                            padding: '4px 8px',
                            color: '#eee',
                        }
                }
                onContextMenu={(e) => handleContextMenuOpen(e, node)}
            >
                <span>{props.item.text}</span>
                {/* <Popup show={show} offset={offset}>
                <Menu vertical={true} style={{ display: 'inline-block' }}>
                    <MenuItem text="Item1">
                        <MenuItem text="Item1.1" />
                        <MenuItem text="Item1.2">
                            <MenuItem text="Item1.2.1" />
                            <MenuItem text="Item1.2.2" />
                        </MenuItem>
                    </MenuItem>
                    <MenuItem text="Item2">
                        <MenuItem text="Item2.1" />
                        <MenuItem text="Item2.2" />
                    </MenuItem>
                    <MenuItem text="Item3" />
                </Menu>
                </Popup> */}
                {/* <TreeItemMenu 
                    menuId={props.item.node.CategoryId}
                    onCategoryClick={getCategoryOnClick(node.CategoryId, node.ParentId)}
                    onSubCategoryClick={getSubCategoryOnClick(node.CategoryId, node.ParentId)}
                    onRenameClick={getRenameOnClick(node.CategoryId, node.ParentId)}
                    onDeleteClick={getRemoveOnClick(node.CategoryId, node.ParentId)}
                    // inContextRef={}

                /> */}
            </div>
        )
    }

    const onItemClick = (event) => {
        if (props.canChangeCategory()) {
            if (selectedItem) {
                selectedItem.selected = false
            }
            event.item.selected = true
            props.setCurrentCategory(event.item.node.CategoryId)
            setSelectedItem(event.item)
        } else {
            props.openSaveDialog(event.item.node.CategoryId, () => {
                if (selectedItem) {
                    selectedItem.selected = false
                }
                event.item.selected = true
                setSelectedItem(event.item)
            })
        }
    }

    const onExpandChange = (event) => {
        event.item.expanded = !event.item.expanded
    }

    let addCategory = (parentId, newCatName) => {
        let url = `${ADD_SUBCATEGORY_URL}/${parentId}`
        fetch(url, {
            method: 'POST',
            credentials: 'include',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ CategoryAdded: { Name: newCatName } }),
        })
            .then((resp) => {
                if (resp.ok) {
                    props.setAlertText(ADD_CATEGORY_SUCCESSFUL_TEXT)
                    props.refreshTree()
                } else {
                    return resp.text()
                }
            })
            .then((resp) => {
                if (resp) alert(resp)
            })
            .catch((e) => {
                console.warn('Add Category Error', e)
            })
    }

    // delete Info = {ErrorString: "", PartCount:"", CategoryCount:""} (confirming category state didnt change from confirmation to submition)
    let removeCategoryRecursive = (nodeId, deleteInfo) => {
        let url = `${DELETE_RECURSIVE_URL}/${nodeId}`
        fetch(url, {
            method: 'POST',
            credentials: 'include',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(deleteInfo),
        })
            .then((resp) => {
                if (resp.ok) {
                    // make the visual change
                    props.setAlertText(DELETE_SUCCESSFUL_TEXT)
                    if (props.currentCategory) {
                        // change category if removing self or category above
                        let needCatChange = props.currentCategory === nodeId
                        let currentNode = treeDict[props.currentCategory].node
                        while (!needCatChange && currentNode.ParentId !== -1) {
                            if (
                                currentNode.ParentId === nodeId ||
                                currentNode.CategoryId === nodeId
                            ) {
                                needCatChange = true
                            }
                            currentNode = treeDict[currentNode.ParentId].node
                        }

                        if (needCatChange) {
                            props.setCurrentCategory(false)
                        }
                    }

                    props.refreshTree()
                } else {
                    return resp.text()
                }
            })
            .then((resp) => {
                if (resp) alert(resp)
            })
            .catch((e) => {
                console.warn('Delete Category Error', e)
            })
    }

    let addSubCategory = (nodeId, newCatName) => {
        let url = `${ADD_SUBCATEGORY_URL}/${nodeId}`
        fetch(url, {
            method: 'POST',
            credentials: 'include',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ CategoryAdded: { Name: newCatName } }),
        })
            .then((resp) => {
                if (resp.ok) {
                    props.setAlertText(ADD_SUBCATEGORY_SUCCESSFUL_TEXT)
                    props.refreshTree()
                } else {
                    return resp.text()
                }
            })
            .then((resp) => {
                if (resp) alert(resp)
            })
            .catch((e) => {
                console.warn('Add Category Error', e)
            })
    }

    let renameCategory = (nodeId, newCatName) => {
        let payload = {
            CategoryChanged: { Name: newCatName },
        }
        let save_url = CAT_SAVE_URL + nodeId
        fetch(save_url, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
        })
            .then(async (resp) => {
                if (resp.ok) return resp.text()
                else if (resp.status > 399 && resp.status < 500) {
                    throw new Error(await resp.text())
                } else {
                    throw new Error('Bad response')
                }
            })
            .then((resp) => {
                props.setAlertText(RENAME_CATEGORY_SUCCESSFUL_TEXT)
                props.refreshTree()
            })
            .catch((e) => {
                alert('failed to save')
            })
    }

    let moveCategory = (sourceNodeId, destNodeId) => {
        let url = `${MOVE_CATEGORY_URL}/${sourceNodeId}/${destNodeId}`
        fetch(url, {
            method: 'POST',
            credentials: 'include',
        })
            .then((resp) => {
                if (resp.ok) {
                    // window.location.reload(false);
                    props.setAlertText(MOVE_SUCCESSFUL_TEXT)
                    // visuallyMoveCategory(sourceNodeId, destNodeId)
                    props.refreshTree()
                } else {
                    return resp.text()
                }
            })
            .then((resp) => {
                if (resp) alert(resp)
            })
            .catch((e) => {
                console.warn('Move Category Error', e)
            })
    }

    let mergeCategories = (sourceNodeId, destNodeId) => {
        let url = `${MERGE_CATEGORY_URL}/${sourceNodeId}/${destNodeId}`
        fetch(url, {
            method: 'POST',
            credentials: 'include',
        })
            .then((resp) => {
                if (resp.ok) {
                    // window.location.reload(false);
                    props.setAlertText(MERGE_CATEGORY_SUCCESSFUL_TEXT)
                    //visuallyMergeCategory(treeInfo[sourceNodeId].node.ParentId,sourceNodeId, destNodeId)
                    if (props.currentCategory) {
                        // change category if removing self or category above
                        let needCatChange = props.currentCategory === sourceNodeId
                        let currentNode = treeDict[props.currentCategory].node
                        while (!needCatChange && currentNode.ParentId !== -1) {
                            if (
                                currentNode.ParentId == sourceNodeId ||
                                currentNode.CategoryId == sourceNodeId
                            ) {
                                needCatChange = true
                            }
                            currentNode = treeDict[currentNode.ParentId].node
                        }

                        if (needCatChange) {
                            props.setCurrentCategory(false)
                        }
                    }

                    props.refreshTree()
                } else {
                    return resp.text()
                }
            })
            .then((resp) => {
                if (resp) alert(resp)
            })
            .catch((e) => {
                console.warn('Merge Category Error', e)
            })
    }

    const getCategoryOnClick = (nodeId, parentId) => {
        return () => {
            let parentNode = treeDict[parentId].node
            let title = 'Add Category'
            let text = 'Enter name for new category to add'
            text += parentNode ? ` to ${parentNode.Name}` : ''
            let submitText = 'Add'
            setCurrentModal(
                <OneFieldModal
                    submitText={submitText}
                    title={title}
                    text={text}
                    submit={(name) => {
                        addCategory(parentId, name)
                        setCurrentModal(null)
                    }}
                    close={() => setCurrentModal(null)}
                />
            )
        }
    }
    const getSubCategoryOnClick = (nodeId, parentId) => {
        let parentNode = treeDict[nodeId].node
        let title = 'Add Subcategory'
        let text = `Enter name for new category to add to ${parentNode.Name}`
        let submitText = 'Add'
        return () => {
            setCurrentModal(
                <OneFieldModal
                    submitText={submitText}
                    text={text}
                    title={title}
                    submit={(name) => {
                        addSubCategory(nodeId, name)
                        setCurrentModal(null)
                    }}
                    close={() => setCurrentModal(null)}
                />
            )
        }
    }

    const getRemoveOnClick = (nodeId, parentId) => {
        let parentNode = treeDict[parentId].node
        let node = treeDict[nodeId].node
        let title = `Are you sure you want to delete '${node.Name}'? This will delete all subcategories`
        let submitText = 'DELETE'
        return () => {
            setCurrentModal(
                <DeleteCatModal
                    categoryId={nodeId}
                    categoryName={node.Name}
                    submit={(deleteInfo) => {
                        removeCategoryRecursive(nodeId, deleteInfo)
                        setCurrentModal(null)
                    }}
                    close={() => setCurrentModal(null)}
                />
            )
        }
    }

    const getRenameOnClick = (nodeId, parentId) => {
        let node = treeDict[nodeId].node
        let title = `Rename ${node.Name}`
        let text = `Enter new name for the category '${node.Name}'`
        let submitText = 'Rename'
        return () => {
            setCurrentModal(
                <OneFieldModal
                    submitText={submitText}
                    default={node.Name}
                    title={title}
                    text={text}
                    submit={(name) => {
                        renameCategory(nodeId, name)
                        setCurrentModal(null)
                    }}
                    close={() => setCurrentModal(null)}
                />
            )
        }
    }

    let dropTreeItemFunc = (sourceNode, destNode) => {
        if (sourceNode === destNode) return
        //sourceNode, destNode, move, merge, close
        let sourceIsLeaf = treeDict[sourceNode].children.length === 0
        let destIsLeaf = treeDict[destNode].children.length === 0
        let destIsPartless = treeDict[destNode].node.PartCount === 0
        if (destIsLeaf && !destIsPartless && sourceIsLeaf) {
            setCurrentModal(
                <MoveOrMergeModal
                    sourceNode={treeDict[sourceNode].node.Name || '* No Name *'}
                    destNode={treeDict[destNode].node.Name || '* No Name *'}
                    move={() => null}
                    merge={() => {
                        mergeCategories(sourceNode, destNode)
                        setCurrentModal(null)
                    }}
                    close={() => setCurrentModal(null)}
                    moveDisabled={true}
                    mergeDisabled={false}
                />
            )
        } else if (destIsLeaf && destIsPartless && sourceIsLeaf) {
            setCurrentModal(
                <MoveOrMergeModal
                    sourceNode={treeDict[sourceNode].node.Name || '* No Name *'}
                    destNode={treeDict[destNode].node.Name || '* No Name *'}
                    move={() => {
                        moveCategory(sourceNode, destNode)
                        setCurrentModal(null)
                    }}
                    merge={() => {
                        mergeCategories(sourceNode, destNode)
                        setCurrentModal(null)
                    }}
                    close={() => setCurrentModal(null)}
                    moveDisabled={false}
                    mergeDisabled={false}
                />
            )
        } else if (!destIsLeaf && !sourceIsLeaf) {
            setCurrentModal(
                <MoveOrMergeModal
                    sourceNode={treeDict[sourceNode].node.Name || '* No Name *'}
                    destNode={treeDict[destNode].node.Name || '* No Name *'}
                    move={() => {
                        moveCategory(sourceNode, destNode)
                        setCurrentModal(null)
                    }}
                    merge={() => {
                        mergeCategories(sourceNode, destNode)
                        setCurrentModal(null)
                    }}
                    close={() => setCurrentModal(null)}
                    moveDisabled={false}
                    mergeDisabled={false}
                />
            )
        } else if (sourceIsLeaf && !destIsLeaf) {
            setCurrentModal(
                <MoveOrMergeModal
                    sourceNode={treeDict[sourceNode].node.Name || '* No Name *'}
                    destNode={treeDict[destNode].node.Name || '* No Name *'}
                    move={() => {
                        moveCategory(sourceNode, destNode)
                        setCurrentModal(null)
                    }}
                    merge={() => null}
                    close={() => setCurrentModal(null)}
                    moveDisabled={false}
                    mergeDisabled={true}
                />
            )
        }
    }

    const onItemDragEnd = (e: DragEndEvent) => {
        const eventAnalyzer = new TreeViewDragAnalyzer(e).init()
        dragClueRef.current.hide()
        let itemIndex = eventAnalyzer.destinationMeta.itemHierarchicalIndex
        if (!itemIndex) return
        let destNode = getItemFromIndex(props.treeInfo, itemIndex)
        let sourceNode = e.item

        let destParentIndex = getParentIndex(itemIndex)
        let sourceParentIndex = getParentIndex(e.itemHierarchicalIndex)
        if (alphaOrder) {
            // @ts-ignore
            dropTreeItemFunc(sourceNode.node.CategoryId, destNode.node.CategoryId)
            return
        }

        switch (eventAnalyzer.getDropOperation()) {
        case 'child':
            // @ts-ignore
            dropTreeItemFunc(sourceNode.node.CategoryId, destNode.node.CategoryId)
            break
        case 'before':
            // Moving outside of a category needs to be done through modal
            if (destParentIndex !== sourceParentIndex) {
                // @ts-ignore
                dropTreeItemFunc(sourceNode.node.CategoryId, destNode.node.CategoryId)
                break
            }
            props.setTreeInfo((tree) => {
                // Remove item from source
                let source_indices = e.itemHierarchicalIndex.split(SEPARATOR)
                let source_ind = parseInt(source_indices.pop())
                let sourceParentIndex = source_indices.join(SEPARATOR)
                let sourceParentNode: any = getItemFromIndex(props.treeInfo, sourceParentIndex)
                sourceParentNode.items
                    ? sourceParentNode.items.splice(source_ind, 1)
                    : sourceParentNode.splice(source_ind, 1)

                // add item to dest
                let dest_indices = itemIndex.split(SEPARATOR)
                dest_indices.pop()
                let destParentIndex = dest_indices.join(SEPARATOR)
                let parentNode: any = getItemFromIndex(props.treeInfo, destParentIndex)
                // @ts-ignore
                let dest_ind = parentNode.items
                    ? parentNode.items.findIndex((x) => x.node.Name === destNode.node.Name)
                    : parentNode.findIndex((x) => x.node.Name === destNode.node.Name)
                parentNode.items
                    ? parentNode.items.splice(dest_ind, 0, e.item)
                    : parentNode.splice(dest_ind, 0, e.item)
                return [...tree]
            })
            break
        case 'after':
            // Moving outside of a category needs to be done through modal
            if (destParentIndex !== sourceParentIndex) {
                // @ts-ignore
                dropTreeItemFunc(sourceNode.node.CategoryId, destNode.node.CategoryId)
                break
            }

            props.setTreeInfo((tree) => {
                // Remove item from source
                let source_indices = e.itemHierarchicalIndex.split(SEPARATOR)
                let source_ind = parseInt(source_indices.pop())
                let sourceParentIndex = source_indices.join(SEPARATOR)
                let sourceParentNode: any = getItemFromIndex(props.treeInfo, sourceParentIndex)
                sourceParentNode.items
                    ? sourceParentNode.items.splice(source_ind, 1)
                    : sourceParentNode.splice(source_ind, 1)

                // add item to dest
                let dest_indices = itemIndex.split(SEPARATOR)
                dest_indices.pop()
                let destParentIndex = dest_indices.join(SEPARATOR)
                let parentNode: any = getItemFromIndex(props.treeInfo, destParentIndex)
                // @ts-ignore
                let dest_ind = parentNode.items
                    ? parentNode.items.findIndex((x) => x.node.Name === destNode.node.Name)
                    : parentNode.findIndex((x) => x.node.Name === destNode.node.Name)
                parentNode.items
                    ? parentNode.items.splice(dest_ind + 1, 0, e.item)
                    : parentNode.splice(dest_ind + 1, 0, e.item)
                return [...tree]
            })

            break

        default:
            break
        }
    }

    const onItemDragStart = (e: DragStartEvent) => {
        // console('Dragging', e.item)
    }

    const onItemDragOver = (e: DragOverEvent) => {
        dragClueRef.current.show(e.pageY + 10, e.pageX, e.item.text, getDragClueClass(e))
    }

    const getDragClueClass = (event) => {
        const eventAnalyzer = new TreeViewDragAnalyzer(event).init()
        const { itemHierarchicalIndex: itemIndex } = eventAnalyzer.destinationMeta
        if (!itemIndex) return 'k-i-cancel'
        let destNode = getItemFromIndex(props.treeInfo, itemIndex)
        let sourceNode = event.item
        let destParentIndex = getParentIndex(itemIndex)
        let sourceParentIndex = getParentIndex(event.itemHierarchicalIndex)
        if (eventAnalyzer.isDropAllowed) {
            if (destParentIndex !== sourceParentIndex || alphaOrder) return 'k-i-plus'
            switch (eventAnalyzer.getDropOperation()) {
            case 'child':
                return 'k-i-plus'
            case 'before':
                return itemIndex === '0' || itemIndex.endsWith(`${SEPARATOR}0`)
                    ? 'k-i-insert-up'
                    : 'k-i-insert-middle'
            case 'after':
                // const siblings = getSiblings(itemIndex, this.state.tree);
                // const lastIndex = Number(itemIndex.split(SEPARATOR).pop());

                // return lastIndex < siblings.length - 1 ? 'k-i-insert-middle' : 'k-i-insert-down';
                return 'k-i-insert-middle'
            default:
                break
            }
        }

        return 'k-i-cancel'
    }

    const selectedStyle = {
        color: '#fff',
        backgroundColor: '#7287a4',
        marginLeft: 20,
        cursor: 'pointer',
    }
    const notSelectedStyle = {
        color: '#7287a4',
        marginLeft: 20,
        cursor: 'pointer',
    }

    return (
        <div style={{ height: '100%' }}>
            <div style={{ height: 40, fontSize: 'x-large', paddingLeft: 20 }}>Category Forms</div>
            <div
                style={{
                    height: 'calc(100% - 90px)',
                    overflow: 'auto auto',
                    borderTopStyle: 'solid',
                    borderTopWidth: 1,
                    borderTopColor: 'rgba(235, 235, 235, 0.8)',
                }}
            >
                <TreeView
                    data={props.treeInfo ? props.treeInfo : []}
                    expandIcons={true}
                    onExpandChange={onExpandChange}
                    onItemClick={onItemClick}
                    onItemDragStart={onItemDragStart}
                    onItemDragEnd={onItemDragEnd}
                    onItemDragOver={onItemDragOver}
                    aria-multiselectable={true}
                    item={(props) => <TreeViewItem {...props} />}
                    draggable={true}
                />
            </div>
            <div
                style={{
                    height: 50,
                    alignItems: 'center',
                    justifyContent: 'center',
                    display: 'flex',
                }}
            >
                <ImportExportIcon
                    fontSize="large"
                    style={alphaOrder ? notSelectedStyle : selectedStyle}
                    onClick={() => setAlphaOrder(false)}
                />
                <SortByAlphaIcon
                    fontSize="large"
                    style={alphaOrder ? selectedStyle : notSelectedStyle}
                    onClick={() => setAlphaOrder(true)}
                />
            </div>
            <TreeViewDragClue ref={(dragClue) => (dragClueRef.current = dragClue)} />
            {currentModal}
            <Popup
                offset={contextOffset}
                show={contextOpen}
                // open={this.onPopupOpen}
                popupClass={'popup-content'}
            >
                <div
                // onFocus={this.onFocusHandler}
                // onBlur={this.onBlurHandler}
                // tabIndex={-1}
                // ref={el => (this.menuWrapperRef = el)}
                >
                    <KMenu
                        vertical={true}
                        style={{ display: 'inline-block' }}
                        onSelect={handleOnSelect}
                    >
                        <KMenuItem text="Add">
                            <KMenuItem text="Category" />
                            <KMenuItem text="SubCategory" />
                        </KMenuItem>
                        <KMenuItem text="Rename" />
                        <KMenuItem text="Delete" />
                    </KMenu>
                </div>
            </Popup>
        </div>
    )
}
export default TreePanel
